import * as React from "react";
const SvgFiRrAnchor = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-anchor_svg__a)">
      <path
        fill="#062147"
        d="M23.392 13.001A2.7 2.7 0 0 0 21.289 12h-1.29a1 1 0 1 0 0 2h1.29a.71.71 0 0 1 .552.264c.076.093.196.29.14.557-.882 4.291-5.1 6.758-8.98 7.125V14h2a1 1 0 1 0 0-2h-2V7.858c1.72-.447 3-2 3-3.858 0-2.206-1.794-4-4-4S8 1.794 8 4c0 1.858 1.28 3.411 3 3.858V12H9a1 1 0 0 0 0 2h2v7.946c-3.88-.367-8.1-2.834-8.982-7.125a.66.66 0 0 1 .14-.558.71.71 0 0 1 .553-.264H4a1 1 0 0 0 0-2H2.71c-.816 0-1.582.364-2.101 1a2.66 2.66 0 0 0-.551 2.226C1.245 20.986 6.963 24 11.999 24c5.038 0 10.756-3.014 11.94-8.775a2.66 2.66 0 0 0-.547-2.224M10 4c0-1.103.897-2 2-2s2 .897 2 2-.897 2-2 2-2-.897-2-2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-anchor_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAnchor;
